<app-custom-calendar-week-view
  class="cal-day-view"
  [daysInWeek]="1"
  [viewDate]="viewDate"
  [events]="events"
  [minimumEventCardWidth]="minimumEventCardWidth"
  [maximumEventCardWidth]="maximumEventCardWidth"
  [stickyBottomScrollbar]="stickyBottomScrollbar"
  [hourSegments]="hourSegments"
  [hourDuration]="hourDuration"
  [hourSegmentHeight]="hourSegmentHeight"
  [minimumEventHeight]="minimumEventHeight"
  [dayStartHour]="dayStartHour"
  [dayStartMinute]="dayStartMinute"
  [dayEndHour]="dayEndHour"
  [dayEndMinute]="dayEndMinute"
  [refresh]="refresh"
  [locale]="locale"
  [eventSnapSize]="eventSnapSize"
  [tooltipPlacement]="tooltipPlacement"
  [tooltipTemplate]="tooltipTemplate"
  [tooltipAppendToBody]="tooltipAppendToBody"
  [tooltipDelay]="tooltipDelay"
  [resizeCursors]="resizeCursors"
  [hourSegmentTemplate]="hourSegmentTemplate"
  [eventTemplate]="eventTemplate"
  [eventTitleTemplate]="eventTitleTemplate"
  [eventActionsTemplate]="eventActionsTemplate"
  [snapDraggedEvents]="snapDraggedEvents"
  [allDayEventsLabelTemplate]="allDayEventsLabelTemplate"
  [currentTimeMarkerTemplate]="currentTimeMarkerTemplate"
  [validateEventTimesChanged]="validateEventTimesChanged"
  (eventClicked)="eventClicked.emit($event)"
  (hourSegmentClicked)="hourSegmentClicked.emit($event)"
  (eventTimesChanged)="eventTimesChanged.emit($event)"
  (beforeViewRender)="beforeViewRender.emit($event)"
></app-custom-calendar-week-view>
